import { Outlet } from 'react-router-dom';
import * as Styled from '../App.styled';
import AppBar from '../features/AppBar/AppBar';
import { Sidebar } from '../features/Sidebar/Sidebar';
import { ErrorNotifications } from '../components/ErrorBanner/ErrorBanner';
import AppInsights from '../components/AppInsights/AppInsights';

export const Layout = () => {
  return (
    <Styled.LayoutGrid>
      <AppInsights />
      <AppBar />
      <Styled.ContentArea>
        <Sidebar />
        <Styled.OutletColumn>
          <ErrorNotifications />
          <Styled.OutletWrapper>
            <Outlet />
          </Styled.OutletWrapper>
        </Styled.OutletColumn>
      </Styled.ContentArea>
    </Styled.LayoutGrid>
  );
};
